import {
  useMatch,
  Outlet,
  NavLink,
  useParams,
  generatePath,
} from 'react-router-dom';
import { IconRight, Tabs } from '@ui/src';
import { useAppSelector } from '@store';
import { OverviewStatementsTypes } from './types';

import cn from '../customers.module.css';

const OverviewStatements = ({
  matchPath,
  cardsRoute,
  routes,
  accounts,
  cards,
  cardsEnabled,
  balances,
  type,
}: OverviewStatementsTypes) => {
  const { accountId } = useAppSelector((state) => state.customerStatements);

  const { customerId } = useParams();
  const match = useMatch(matchPath);

  const currentAccount = accounts?.find((item) => item.id === accountId);

  return (
    <div className={cn.overviewStatements}>
      {type !== 'COMPANY_OFFICIAL' && (
        <>
          <div className={cn.overviewStatementsTitle}>
            Statement of account
            <NavLink
              className={`${cn.overviewStatementsTitleLink} ${
                !accountId ? cn.overviewStatementsTitleLinkDisabled : ''
              }`}
              to={
                match
                  ? `/accounts/statements?account=${currentAccount?.fullNumber}`
                  : generatePath(cardsRoute, { customerId })
              }
            >
              View all
              <IconRight />
            </NavLink>
          </div>
          {cardsEnabled && (
            <div className={cn.overviewStatementsTabs}>
              <Tabs
                tabs={[
                  {
                    name: 'Account transactions',
                    path: generatePath(routes.transationRoute, {
                      customerId,
                    }),
                  },
                  {
                    name: 'Card transactions',
                    path: generatePath(routes.cardsRoute, {
                      customerId,
                    }),
                  },
                ]}
                enableRouting
              />
            </div>
          )}
        </>
      )}

      <Outlet context={{ accounts, cards, currentAccount, balances }} />
    </div>
  );
};

export default OverviewStatements;
